import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, SimpleChanges, ViewEncapsulation, OnChanges, Input, ViewChild, ContentChild } from '@angular/core';
import { Timeline } from '@swimlane/ngx-charts';
import { select } from 'd3-selection';
import { of } from 'rxjs';
import { debounceTime, first, tap } from 'rxjs/operators/';


/**
 * Override of element Timeline for do the function requested at https://app.asana.com/0/1156796691380146/1199719364935717.
 *
 * @export
 * @class CustomTimelineChartComponent
 * @extends {Timeline}
 */
@Component({
  selector: 'g[app-custom-timeline-chart]',
  template: `
    <svg:g class="timeline" [attr.transform]="transform">
      <svg:filter [attr.id]="filterId">
        <svg:feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
        />
      </svg:filter>
      <svg:g class="embedded-chart">
        <ng-content></ng-content>
      </svg:g>
      <svg:rect x="0" [attr.width]="view[0]" y="0" [attr.height]="height" class="brush-background" />
      <svg:g class="brush"></svg:g>
    </svg:g>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['../../../../../node_modules/@swimlane/ngx-charts/release/common/timeline/timeline.component.css']
})
export class CustomTimelineChartComponent extends Timeline implements OnChanges {

  /**
   * Custom filtered name to call brush move.
   *
   * @memberof CustomTimelineChartComponent
   */
  @Input() filteredDomain;
  constructor(element: ElementRef, public chd: ChangeDetectorRef) {
    super(element, chd);
  }

  /**
   * Override the method for perform changes.
   *
   * @param {SimpleChanges} changes
   * @memberof CustomTimelineChartComponent
   */
  ngOnChanges(changes:SimpleChanges){
    // Call the default method.
    super.ngOnChanges(changes);
    if('filteredDomain' in changes){
      // If the filtered domain have data, check if this should change.
      const shouldChange = changes.filteredDomain.currentValue && changes.filteredDomain.previousValue &&
      (changes.filteredDomain.currentValue[0].getTime() !==  changes.filteredDomain.previousValue[0].getTime()
      ||
      changes.filteredDomain.currentValue[1].getTime() !==  changes.filteredDomain.previousValue[1].getTime());
      // If brush is init and the data should change.
      if(this.brush && shouldChange){
        // Open a dummy observable.
        of('').pipe(
          // Set some debounce time for avoid infinite loop.
          debounceTime(1000),
          // Get only the first.
          first(),
          tap(a=>{
            // Map the filtered domain as timestamps.
            const filteredDomainMapped = this.filteredDomain.map(value=> value.getTime())
            // Calculate the points inverted.
            const points = [this.xScale(filteredDomainMapped[0]), this.xScale(filteredDomainMapped[1])];
            // Perform the move.
            select(this.element).select('.brush').call(this.brush.move, [points[0], points[1]])
            this.chd.markForCheck();
          })
        ).subscribe();
      }
    }
  }

}
